import { useEffect } from "react";
import { Navigate, useParams, useLocation } from "react-router-dom";
import { getTableById, getTableRk } from "@/helpers/apis";
import { useQuery } from "@tanstack/react-query";
import { ComponentLoader } from "../../components/loader";
import { useResourceOpportunities } from "@/helpers/useTimeHooks";
import { ResourceType } from "../explorer/types";
import { MainContent } from "./components/MainContent";
import { useBreadcrumb, getEntityName } from "@/components/breadcrumbs";
import { getEntityFromScope } from "./utils";
import { DatasetsTracking } from "@/lib/tracking/datasets";

export const GET_TABLE_RK = "GET-TABLE-RK";
export const GET_TABLE_BY_ID = "GET-TABLE-BY-ID";

const DatasetsDetails = () => {
  const { tableId } = useParams();
  const { state } = useLocation();

  const { data: tableRk, isLoading: isTableRkLoading } = useQuery({
    queryKey: [GET_TABLE_RK, tableId],
    queryFn: () => getTableRk(tableId!),
    enabled: !!tableId,
  });
  const opportunities = useResourceOpportunities({
    resourceUri: tableRk?.table_rk,
    resourceType: ResourceType.Table,
  });

  const { data: table, isLoading: isTableLoading } = useQuery({
    queryKey: [GET_TABLE_BY_ID, tableId],
    queryFn: () => getTableById(tableId!),
    enabled: !!tableId,
  });

  const tableName = table?.scope ? getEntityFromScope(table.scope).table : null;
  // Use location state as fallback for instant display
  useBreadcrumb(getEntityName(state) ?? tableName ?? "Loading...", {
    defaultParents: [{ label: "Datasets", pathname: "/datasets" }],
  });

  useEffect(() => {
    if (tableId && tableName) {
      DatasetsTracking.detailViewed(tableId, tableName);
    }
  }, [tableId, tableName]);

  if (isTableRkLoading || opportunities.isFetching || isTableLoading) {
    return <ComponentLoader label={"Loading..."} />;
  }

  if (!table) {
    return <Navigate to="/datasets" />;
  }

  return (
    <MainContent
      tableId={tableId}
      opportunities={opportunities?.data?.data || []}
      table_rk={tableRk?.table_rk}
      table={table}
    />
  );
};

export { DatasetsDetails };
